import { render } from "./VacationHistory.vue?vue&type=template&id=2a218162&scoped=true"
import script from "./VacationHistory.vue?vue&type=script&lang=js"
export * from "./VacationHistory.vue?vue&type=script&lang=js"

import "./VacationHistory.vue?vue&type=style&index=0&id=2a218162&scoped=true&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a218162"]])

export default __exports__